// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import * as types from './actionTypes';

export function startRecentLoader() {
  return {
    type: types.VOUCHERS_START_RECENT_LOADER,
  };
}

export function stopRecentLoader() {
  return {
    type: types.VOUCHERS_STOP_RECENT_LOADER,
  };
}

export function startSearchLoader() {
  return {
    type: types.VOUCHERS_START_SEARCH_LOADER,
  };
}

export function stopSearchLoader() {
  return {
    type: types.VOUCHERS_STOP_SEARCH_LOADER,
  };
}

export function getBookshopTotal() {
  return {
    type: types.GET_BOOKSHOP_TOTAL,
  };
}

export function getBookshopTotalSuccess(payload) {
  return {
    type: types.GET_BOOKSHOP_TOTAL_SUCCESS,
    payload,
  };
}

export function getRecentVouchers() {
  return {
    type: types.GET_RECENT_VOUCHERS,
  };
}

export function getRecentVouchersSuccess(payload) {
  return {
    type: types.GET_RECENT_VOUCHERS_SUCCESS,
    payload
  };
}

export function changeSearchField(value, field) {
  return {
    type: types.CHANGE_SEARCH_FIELD,
    value,
    field,
  };
}

export function searchVouchers() {
  return {
    type: types.SEARCH_VOUCHERS,
  };
}

export function searchVouchersSuccess(payload) {
  return {
    type: types.SEARCH_VOUCHERS_SUCCESS,
    payload
  };
}

export function clearSearchResult() {
  return {
    type: types.VOUCHERS_CLEAR_SEARCH_RESULT
  };
}
